module.exports = __webpack_public_path__ + "static/media/chess.d4163df9.gif";